import React, { useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import MainLayout from "components/Layouts/MainLayout";
import { Breadcrumb } from "antd";
import useDeviceType from "Utils/useDeviceType";
import style from "./index.module.scss";
import {
    getSignInInfo,
    SignStatus,
    StuSignInStatus,
    getOnlineSignInInfo,
    SignInInfo,
    SignType
} from "API/signIn";
import { toNumber } from "../../homework/utils/filter";
import SignInput from "./components/SignInput";
import SignResult from "./components/SignResult";
import SignHeader from "./components/SignHeader";
import CourseError from "../components/CourseError";
import { errorMessage } from "Utils/useRequest";
import { ResultMessage } from "components/ResultMessage";

interface SignInDetailProps {
    id: string;
    type: string; //签到类型
}

export default function SignInDetail({
    match
}: RouteComponentProps<SignInDetailProps>) {
    const signInId = toNumber(match.params.id);
    const type = match.params.type;
    const history = useHistory();
    const { isPC } = useDeviceType();
    const [signDetail, setSignDetail] = useState<SignInInfo>();
    const [error, setError] = useState();

    useEffect(() => {
        if (!type) return;
        getSignInDetail(type);
    }, [type]);

    async function getSignInDetail(type: string) {
        try {
            if (type === String(SignType.Live)) {
                const data = await getOnlineSignInInfo(signInId);
                setSignDetail(data);
            } else {
                const data = await getSignInInfo(signInId);
                setSignDetail(data);
            }
        } catch (e) {
            setError(e);
            ResultMessage.error(errorMessage(e));
        }
    }

    // 是否已签到
    const isSignIn = [
        StuSignInStatus.Leave,
        StuSignInStatus.Late,
        StuSignInStatus.Done
    ].includes(signDetail?.signStatus as any);

    // 是否显示数字码(注意, 普通签到也显示数字码)
    const showPinInput =
        signDetail?.signStatus === StuSignInStatus.Idle &&
        signDetail?.signInModel.status !== SignStatus.Done;

    const breadcrumb = (
        <Breadcrumb separator=">">
            <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
            <Breadcrumb.Item onClick={history.goBack}>课程内容</Breadcrumb.Item>
            <Breadcrumb.Item>提交签到</Breadcrumb.Item>
        </Breadcrumb>
    );

    if (error) return <CourseError breadcrumb={breadcrumb} />;

    return (
        <MainLayout className={style.root} title="提交签到">
            {isPC && breadcrumb}

            <div className={style.body}>
                <SignHeader data={signDetail} type={type} />

                {signDetail && showPinInput && (
                    <SignInput
                        signInId={signInId}
                        onComplete={() => getSignInDetail(type)}
                        type={signDetail.signInModel.type}
                    />
                )}
                {isSignIn && (
                    <SignResult
                        type="success"
                        tip="签到成功"
                        signTime={signDetail?.signInTime}
                    />
                )}
                {signDetail?.signStatus === StuSignInStatus.Idle &&
                    signDetail?.signInModel.status === SignStatus.Done && (
                        <SignResult type="fail" tip="签到活动已结束" />
                    )}
            </div>
        </MainLayout>
    );
}
